import WorkExperience from "./WorkExperience"
export default WorkExperience
